// extracted by mini-css-extract-plugin
export default {"loading":"loading_loading__wviUp","background":"loading_background__caDeq","container":"loading_container__EEeZh"};